"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTreeNodeType = void 0;
const FormQuestionControllerRegistry_1 = __importDefault(require("@opsbase/lib-form/FormQuestionController/FormQuestionControllerRegistry"));
const FormQuestionType_1 = __importStar(require("@opsbase/lib-form/FormQuestionType"));
const getAllChildQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/getAllChildQuestions"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useSelf_1 = require("@opsbase/react-ctrl-self/useSelf");
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const AddIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AddIcon"));
const useNotificationActions_1 = __importDefault(require("@opsbase/web-notification/useNotificationActions"));
const IconMenu_1 = __importDefault(require("@opsbase/web-ui/IconMenu"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedDB_1 = __importDefault(require("../FedController/useFedDB"));
const useFedSelect_1 = __importDefault(require("../FedController/useFedSelect"));
const useFedSetup_1 = __importDefault(require("../FedController/useFedSetup"));
const getQuestionAncestors_1 = require("../helpers/getQuestionAncestors");
const QuestionTypeIcon_1 = __importDefault(require("../QuestionTypeIcon/QuestionTypeIcon"));
const makeMyClasses = isSelected => ({
    root: {
        width: 50,
        marginRight: 8,
        padding: '2px 8px 2px 4px',
        borderRight: isSelected
            ? `1px solid ${lib_palette_1.default.secondary.main}`
            : `1px solid ${lib_palette_1.default.LavendarGrey.main}`,
    },
    rootInner: {
        width: 40,
        padding: '6px 8px',
    },
});
exports.QuestionTreeNodeType = react_1.default.memo((props) => {
    const { question, disabled = false } = props;
    const db = (0, useFedDB_1.default)();
    const { selected } = (0, useFedSelect_1.default)();
    const { mode, formConstraints } = (0, useFedSetup_1.default)();
    const { doChangeQuestion, doExpand } = (0, useFedActions_1.default)();
    const { raiseOkCancel } = (0, useNotificationActions_1.default)();
    const isSelected = selected === question.qId;
    const ancestors = (0, getQuestionAncestors_1.getQuestionAncestors)(db, question);
    const myCss = (0, web_css_1.default)(makeMyClasses, [isSelected]);
    const self = (0, useSelf_1.useSelf)();
    const handleChangeType = (0, useCallforward_1.default)(type => () => {
        if (type !== question.type) {
            const childQuestions = (0, getAllChildQuestions_1.default)(question);
            const waitForOk = (childQuestions === null || childQuestions === void 0 ? void 0 : childQuestions.length)
                ? new Promise((onOk, onCancel) => raiseOkCancel(lib_i18n_1.default.t('warn-sub-question-loss'), {
                    okLabel: lib_i18n_1.default.t('change-question-type'),
                    okColor: lib_palette_1.default.error,
                    onOk,
                    onCancel,
                }))
                : Promise.resolve(true);
            waitForOk
                .then(() => {
                doChangeQuestion(question.qId, { type });
                if (type === FormQuestionType_1.default.REPETITION ||
                    type === FormQuestionType_1.default.SECTION) {
                    doExpand(question.qId, true);
                }
            })
                .catch(doNothing_1.default);
        }
    }, [doChangeQuestion, doExpand, question, raiseOkCancel]);
    return (0, react_1.useMemo)(() => {
        if (!isSelected && question.title === '')
            return (react_1.default.createElement("div", { className: myCss.root },
                react_1.default.createElement("div", { className: myCss.rootInner },
                    react_1.default.createElement(AddIcon_1.default, { htmlColor: "#929FA8" }))));
        if (!isSelected || mode === 'view')
            return (react_1.default.createElement("div", { className: myCss.root },
                react_1.default.createElement("div", { className: myCss.rootInner },
                    react_1.default.createElement(QuestionTypeIcon_1.default, { type: question.type, color: lib_palette_1.default.BlackCoral }))));
        const selectableTypes = getSelectableTypes(ancestors, formConstraints, self.features);
        return (react_1.default.createElement("div", { className: myCss.root },
            !disabled && (selectableTypes === null || selectableTypes === void 0 ? void 0 : selectableTypes.length) > 1 && (react_1.default.createElement(IconMenu_1.default, { small: true, color: lib_palette_1.default.secondary, icon: react_1.default.createElement(QuestionTypeIcon_1.default, { type: question.type, color: lib_palette_1.default.White }) }, selectableTypes.map(f => (react_1.default.createElement(MenuItem_1.default, { key: f, value: f, selected: f === question.type, onClick: handleChangeType(f) },
                react_1.default.createElement(QuestionTypeIcon_1.default, { type: f }),
                react_1.default.createElement("div", { style: { marginLeft: 10 } }, (0, FormQuestionType_1.questionTypeLabel)(f))))))),
            (disabled || (selectableTypes === null || selectableTypes === void 0 ? void 0 : selectableTypes.length) <= 1) && (react_1.default.createElement("div", { className: myCss.rootInner },
                question.title === '' && react_1.default.createElement(AddIcon_1.default, { htmlColor: "#929FA8" }),
                question.title !== '' && react_1.default.createElement(QuestionTypeIcon_1.default, { type: question.type })))));
    }, [
        isSelected,
        question,
        myCss,
        mode,
        ancestors,
        formConstraints,
        self,
        disabled,
        handleChangeType,
    ]);
});
exports.default = exports.QuestionTreeNodeType;
function getSelectableTypes(ancestorQuestions, formConstraints, features) {
    var _a, _b, _c;
    let selectableTypes = FormQuestionType_1.AllFormQuestionTypes;
    // Apply Root Level Constraints
    if (!(ancestorQuestions === null || ancestorQuestions === void 0 ? void 0 : ancestorQuestions.length)) {
        selectableTypes = ((_a = formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints.root) === null || _a === void 0 ? void 0 : _a.types) || FormQuestionType_1.AllFormQuestionTypes;
    }
    // Apply Section Question Constraints
    else if (ancestorQuestions[0].type === FormQuestionType_1.default.SECTION) {
        selectableTypes = ((_b = formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints[FormQuestionType_1.default.SECTION]) === null || _b === void 0 ? void 0 : _b.types) || FormQuestionType_1.AllFormQuestionTypes;
    }
    // Apply Section Question Constraints
    else if (ancestorQuestions[0].type === FormQuestionType_1.default.REPETITION) {
        selectableTypes =
            ((_c = formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints[FormQuestionType_1.default.REPETITION]) === null || _c === void 0 ? void 0 : _c.types) || FormQuestionType_1.AllFormQuestionTypes;
    }
    // Only include Types that are Allowed to be selected
    selectableTypes = selectableTypes
        .filter(f => FormQuestionControllerRegistry_1.default[f].isAllowed(ancestorQuestions, features))
        .filter(f => f !== FormQuestionType_1.default.QUESTIONSET);
    return selectableTypes;
}
